import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
          const currentLocation = prevProps.location.pathname;
          const newLocation = this.props.location.pathname;

          let scrollToTop = false;
          if(currentLocation == '/' || newLocation == '/') {
              scrollToTop = true;
          }
          else {
             const currentLocationTokens = currentLocation.split('/').filter((val) => val);
             const newLocationTokens = newLocation.split('/').filter((val) => val);
             if(currentLocationTokens.length == 1 && newLocationTokens.length == 1) {
                  scrollToTop = true;
             }
              else if(currentLocationTokens[0] != newLocationTokens[0]) {
                 //we haven't moved to a nested route, e.g. a tab within the page, scroll to the top
                 scrollToTop = true;
             }         
          }
          if(scrollToTop) {
             window.scrollTo(0, 0);
          }
      }
    }
  
    render() {
      return this.props.children;
    }
  }
  
  ScrollToTop.propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired
};

  export default withRouter(ScrollToTop);